export function initBlogVideos() {
    document.querySelectorAll('[data-blog-video]').forEach((container) => {
        let url;
        try {
            url = new URL(container.dataset.blogVideo);
        } catch {
            return;
        }
        if (!['https:', 'http:'].includes(url.protocol)) return;

        const host = url.hostname.toLowerCase().replace(/^www\./, '');
        const parts = url.pathname.split('/').filter(Boolean);
        let embedUrl;

        if (['youtube.com', 'm.youtube.com', 'youtube-nocookie.com', 'youtu.be'].includes(host)) {
            const id = host === 'youtu.be' ? parts[0]
                : ['embed', 'shorts'].includes(parts[0]) ? parts[1] : url.searchParams.get('v');
            if (/^[a-zA-Z0-9_-]{11}$/.test(id ?? '')) {
                embedUrl = `https://www.youtube-nocookie.com/embed/${id}`;
            }
        } else if (['vimeo.com', 'player.vimeo.com'].includes(host)) {
            const id = host === 'player.vimeo.com' ? parts[1] : parts[0];
            if (/^\d+$/.test(id ?? '')) {
                const embed = new URL(`https://player.vimeo.com/video/${id}`);
                const hash = url.searchParams.get('h') || parts[1];
                if (hash && /^[a-zA-Z0-9]+$/.test(hash)) embed.searchParams.set('h', hash);
                embedUrl = embed.href;
            }
        }

        if (embedUrl) {
            const iframe = document.createElement('iframe');
            iframe.src = embedUrl;
            iframe.title = container.dataset.videoTitle;
            iframe.loading = 'lazy';
            iframe.allow = 'fullscreen; picture-in-picture; encrypted-media';
            iframe.allowFullscreen = true;
            container.replaceChildren(iframe);
        } else if (/\.(mp4|webm)$/i.test(url.pathname)) {
            const video = document.createElement('video');
            video.src = url.href;
            video.controls = true;
            video.preload = 'metadata';
            video.playsInline = true;
            video.setAttribute('aria-label', container.dataset.videoTitle);
            if (container.dataset.videoPoster) video.poster = container.dataset.videoPoster;
            container.replaceChildren(video);
        }
    });
}
